module.exports = __webpack_public_path__ + "static/partner-img-1-b99a89c339cc02ef7e72d94378d3ea75.png";